import { State } from "../types/state";

const resetHistoryUserLocation = (state: State) => {
  state.historyUserLocation = {};
};

export default resetHistoryUserLocation;
